import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { OnlyVisibleActionButtonsService } from '../services/only-visible-action-buttons.service';
import { ActionButton } from '../models/action-button';
import { Nillable } from '@web/utils';

@Pipe({
  name: 'onlyVisibleActionButtons',
  standalone: true,
})
export class OnlyVisibleActionButtonsPipe<Action> implements PipeTransform {
  private readonly onlyVisibleActionButtons = inject<
    OnlyVisibleActionButtonsService<Action>
  >(OnlyVisibleActionButtonsService);

  public transform(
    actions: Nillable<ActionButton<Action>[]>,
  ): Nillable<Observable<ActionButton<Action>[]>> {
    return this.onlyVisibleActionButtons.resolveVisibility(actions);
  }
}
